
$w.onReady(() => {

    waitForLoading();

});

 

export function button6_onClick(event) {

    $w('#preloader').show();

    waitForLoading();

}

 

function waitForLoading() {

    setTimeout(() => {

        $w('#imageX152').hide('FadeOut');

    }, 100);

}

$w.onReady(function () {
    ;

    $w('#readmore').onClick(() => {
        $w('#readmorebox').collapse() ; $w('#readmorebox').expand()
        ; 
    });

});

$w.onReady(function () {
    ;

    $w('#readless').onClick(() => {
        $w('#readmorebox').expand() ; $w('#readmorebox').collapse()
    ; 
    });

});